import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import toast from "react-hot-toast";
import Api_Instance from "../../../api/Api_Instance";
import { ChannelPartner } from "../../../api/endpoints";
import ErrorMessage from "../../../common/errormsg/ErrorMessage";
import { useNavigate } from "react-router-dom";
import CountriesApi from "../../../common/countriesapi/CountriesApi";
import Loader from "../../../common/loader/Loader";
import { useSelector } from "react-redux";
import { EDUCATION_CHOICES, EMPLOYMENT_CHOICES } from "../../../utils/Utils";
function ChannelPartnerRegistration() {
  const api = Api_Instance.useApi();
  const navigate = useNavigate();
  const advertisementData = useSelector((state) => state?.auth?.advertisement_data)
  const [formValues, setFormValues] = useState({
    first_name: "",
    last_name: "",
    mobile_number: "",
    email: "",
    address: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    qualifiaction: "",
    ocuupation: "",
    age: "",
    property_address: "",
    commercial_property: "",
    terms_conditions: false,
    direct_lead: true,
  });
  const [countrydata, setCountrydata] = useState({
    countryid: "",
    stateid: "",
    cityid: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    setFormValues({
      ...formValues,
      [name]: name === "terms_conditions" ? checked : value,
    });
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;
    const validationErrors = validate({
      ...formValues,
      [name]: value,
    });
    setErrors(validationErrors);
  };
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedValues = {};
    Object.keys(formValues).forEach((key) => {
      trimmedValues[key] =
        typeof formValues[key] === "string"
          ? formValues[key].trim()
          : formValues[key];
    });
    const validationErrors = validate(trimmedValues);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setLoading(true);
      try {
        const res = await api(
          "POST",
          ChannelPartner.POST_CHHANEL_PARTNER,
          trimmedValues
        );
        if (res.status) {
          toast.success(res.data.message || "Successfully Created");
          setLoading(false);
          navigate("/");
        }
      } catch (error) {
        toast.error(error?.response?.data?.errors?.email[0] || "Invalid data");
        setLoading(false);
      }
    }
  };

  function formatField(field) {
    let formatted = field.replace(/_/g, " ");
    formatted = formatted.charAt(0).toUpperCase() + formatted.slice(1);
    return formatted;
  }

  const validate = (values) => {
    const errors = {};
    const requiredFields = [
      "first_name",
      "last_name",
      "mobile_number",
      "email",
      "address",
      "country",
      "state",
      "city",
      "pincode",
      "qualifiaction",
      "ocuupation",
      "age",
      "property_address",
      "commercial_property",
    ];
    const emojiRegex =
      /([\u{1F600}-\u{1F64F}|\u{1F300}-\u{1F5FF}|\u{1F680}-\u{1F6FF}|\u{1F700}-\u{1F77F}|\u{1F780}-\u{1F7FF}|\u{1F800}-\u{1F8FF}|\u{1F900}-\u{1F9FF}|\u{1FA00}-\u{1FA6F}|\u{1FA70}-\u{1FAFF}|\u{2600}-\u{26FF}|\u{2700}-\u{27BF}|\u{2300}-\u{23FF}|\u{2B50}|\u{1F004}-\u{1F251}]+|\u{1F004}-\u{1F251}|\u{1F1E6}-\u{1F1FF})/gu;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const pinCodeRegex = /^\d{6}$/;
    const ageRegex = /^\d+$/;

    requiredFields.forEach((field) => {
      const value = values[field];
      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && !value.trim())
      ) {
        if (field != "state" && field != "city") {
          errors[field] = `${formatField(field)} is required`;
        } else if (field == "state" && statedata.length > 0) {
          errors[field] = `${formatField(field)} is required`;
        } else if (field == "city" && citydata.length > 0) {
          errors[field] = `${formatField(field)} is required`;
        }
      }
    });
    if (values.first_name) {
      if (!/^[A-Za-z\s]+$/.test(values.first_name)) {
        errors.first_name = "First name should only contain letters and spaces";
      } else if (values.first_name.length < 2) {
        errors.first_name = "First name must be at least 2 characters";
      } else if (values.first_name.length > 20) {
        errors.first_name = "First name must be at most 20 characters";
      } else if (emojiRegex.test(values.first_name)) {
        errors.first_name = "First name should not contain emojis";
      }
    }

    if (values.last_name) {
      if (!/^[A-Za-z\s]+$/.test(values.last_name)) {
        errors.last_name = "Last name should only contain letters and spaces";
      } else if (values.last_name.length < 2) {
        errors.last_name = "Last name must be at least 2 characters";
      } else if (values.last_name.length > 20) {
        errors.last_name = "Last name must be at most 20 characters";
      } else if (emojiRegex.test(values.last_name)) {
        errors.last_name = "Last name should not contain emojis";
      }
    }
    if (values.address) {
      if (emojiRegex.test(values.address)) {
        errors.address = "Address should not contain emojis";
      }
    }
    if (values.pincode) {
      if (!pinCodeRegex.test(values.pincode)) {
        errors.pincode =
          "Pincode must be exactly 6 digits and contain no letters, spaces, or special characters.";
      }
      if (emojiRegex.test(values.pincode)) {
        errors.pincode = "Pincode should not contain emojis";
      }
    }

    if (values.age) {
      if (emojiRegex.test(values.age)) {
        errors.age = "Age should not contain emojis";
      }
      if (!ageRegex.test(values.age)) {
        errors.age =
          "Age must be a positive number without any letters, special characters, or spaces.";
      } else {
        const ageNumber = Number(values.age);
        if (ageNumber < 18) {
          errors.age = "Age must be at least 18.";
        }
      }
    } else {
      errors.age = "Age is required.";
    }
    if (values.property_address) {
      const addressLength = values.property_address.trim().length;
      if (emojiRegex.test(values.property_address)) {
        errors.property_address = "Property Address should not contain emojis";
      }
      if (addressLength > 150) {
        errors.property_address =
          "Property address must not exceed 150 characters.";
      }
    } else {
      errors.property_address = "Property address is required.";
    }

    if (values.commercial_property) {
      const addressLength = values.commercial_property.trim().length;
      if (emojiRegex.test(values.commercial_property)) {
        errors.commercial_property =
          "Commercial Address should not contain emojis";
      }
      if (addressLength < 20) {
        errors.commercial_property =
          "Commercial address must be at least 20 characters long.";
      } else if (addressLength > 250) {
        errors.commercial_property =
          "Commercial address must not exceed 150 characters.";
      }
    } else {
      errors.commercial_property = "Commercial address is required.";
    }
    if (values.email && !emailRegex.test(values.email)) {
      errors.email = "Email address is invalid";
    }
    const mobileNumberRegex = /^[6-9]\d{9}$/;
    if (values.mobile_number) {
      if (!mobileNumberRegex.test(values.mobile_number)) {
        errors.mobile_number =
          "Mobile number must be exactly 10 digits long, start with 6, 7, 8, or 9, and contain no letters, special characters, or spaces.";
      }
    } else {
      errors.mobile_number = "Mobile number is required.";
    }
    if (!values.terms_conditions) {
      errors.terms_conditions = "Please agree to the Terms & Conditions."
    }
    return errors;
  };
  const handleCountryChange = (event) => {
    const { value, options, selectedIndex } = event.target;
    const selectedCountryName = options[selectedIndex].text;
    setFormValues((prevValues) => ({
      ...prevValues,
      country: value,
      state: "",
      city: "",
    }));
    setCountrydata((prev) => ({
      ...prev,
      countryid: selectedIndex - 1,
    }));
  };
  const { useCountries, States, Ctiy } = CountriesApi;
  const { countries } = useCountries();
  const { statedata } = States(countrydata.countryid);
  const { citydata } = Ctiy(countrydata.stateid);
  const handleStateChange = (event) => {
    const { value, options, selectedIndex } = event.target;
    const selected_id = options[selectedIndex].getAttribute("data-id");
    setFormValues((prevValues) => ({
      ...prevValues,
      state: value,
      city: "",
    }));
    setCountrydata((prev) => ({
      ...prev,
      stateid: selected_id,
    }));
  };
  return (
    <div>
      {/* <div className="bg-subheader_background w-full h-24 flex items-center justify-center">
        <p className="text-2xl font-lg text-text_color">
          Channel Partner Registration
        </p>
      </div> */}
      <div className="w-full max-w-[1250px]     mx-auto xl:px-0 lg:px-0 md:px-5 px-4">
        <div className="bg-white py-8 mx-auto xl:px-0 lg:px-0 md:px-5 px-4">
          <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-start justify-between mx-auto">
            <div className="flex-[0_0_70%]">
              <div className="bg-[#fafafa] p-8 rounded-lg w-full mx-auto">
                <form onSubmit={handleSubmit}>
                  <div className="mb-8">
                    <div className="mb-4">
                      <h3 className="text-2xl font-semibold font-lg text-text_color">
                        Basic Details
                      </h3>
                    </div>
                    <div className="flex flex-col md:flex-row gap-4">
                      <div className="flex-1">
                        <label htmlFor="FirstName" className="mb-1 font-md block capitalize font-semibold">
                          First Name* <span className="text-star_color">*</span>
                        </label>
                        <input
                          type="text"
                          id="FirstName"
                          name="first_name"
                          value={formValues.first_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Enter First Name"
                          className="p-2 border border-gray-300 rounded w-full"
                        />
                        {errors.first_name && (
                          <ErrorMessage error={errors.first_name} />
                        )}
                      </div>
                      <div className="flex-1">
                        <label htmlFor="LastName" className="mb-1 font-md block capitalize font-semibold">
                          Last Name <span className="text-star_color">*</span>
                        </label>
                        <input
                          type="text"
                          id="LastName"
                          name="last_name"
                          value={formValues.last_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Last Name"
                          className="p-2 border border-gray-300 rounded w-full"
                        />
                        {errors.last_name && <ErrorMessage error={errors.last_name} />}
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="">
                      <label htmlFor="Mobile" className="mb-1 font-md block capitalize font-semibold">
                        Mobile <span className="text-star_color">*</span>
                      </label>
                      <input
                        type="text"
                        id="Mobile"
                        name="mobile_number"
                        value={formValues.mobile_number}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Enter Mobile"
                        className="p-2 border border-gray-300 rounded w-full"
                      />

                      {errors.mobile_number && (
                        <ErrorMessage error={errors.mobile_number} />
                      )}
                    </div>
                    <div className="">
                      <label htmlFor="Email" className="mb-1 font-md block capitalize font-semibold">
                        Email <span className="text-star_color">*</span>
                      </label>
                      <input
                        type="text"
                        id="Email"
                        name="email"
                        value={formValues.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Enter Email"
                        className="p-2 border border-gray-300 rounded w-full"
                      />

                      {errors.email && <ErrorMessage error={errors.email} />}
                    </div>
                    <div className="col-span-2">
                      <label htmlFor="Address" className="mb-1 font-md block capitalize font-semibold">
                        Address<span className="text-star_color">*</span>
                      </label>
                      <textarea type="text"
                        id="Address"
                        name="address"
                        value={formValues.address}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Enter Address"
                        className="p-2 border border-gray-300 rounded w-full h-[100px] overflow-auto"></textarea>
                      {errors.address && <ErrorMessage error={errors.address} />}
                    </div>

                    <div className="relative">
                      <label htmlFor="country" className="mb-1 font-md block capitalize font-semibold">
                        Country <span className="text-star_color">*</span>
                      </label>
                      <select
                        id="country"
                        name="country"
                        value={formValues.country}
                        onChange={handleCountryChange}
                        onBlur={handleBlur}
                        className="p-2 border border-gray-300 rounded w-full"
                      >
                        <option value="" disabled>
                          Country
                        </option>
                        {countries?.map((item) => (
                          <option value={item.name}>{item.name}</option>
                        ))}
                      </select>

                      {errors.country && <ErrorMessage error={errors.country} />}
                    </div>
                    <div>
                      <label htmlFor="State" className="mb-1 font-md block capitalize font-semibold">
                        State{" "}
                        {statedata.length > 0 && (
                          <span className="text-star_color">*</span>
                        )}
                      </label>
                      <select
                        id="state"
                        name="State"
                        value={formValues.state}
                        onBlur={handleBlur}
                        onChange={handleStateChange}
                        className="p-2 border border-gray-300 rounded w-full"
                      >
                        <option value="" disabled>
                          State
                        </option>
                        {statedata?.map((item) => (
                          <option value={item.name} data-id={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>

                      {errors.state && <ErrorMessage error={errors.state} />}
                    </div>
                    <div className="relative">
                      <label htmlFor="city" className="mb-1 font-md block capitalize font-semibold">
                        City{" "}
                        {citydata.length > 0 && (
                          <span className="text-star_color">*</span>
                        )}
                      </label>
                      <select
                        id="city"
                        name="city"
                        value={formValues.city}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="p-2 border border-gray-300 rounded w-full"
                      >
                        <option value="" disabled>
                          city
                        </option>
                        {citydata?.map((item) => (
                          <option value={item.name}>{item.name}</option>
                        ))}
                      </select>

                      {errors.city && <ErrorMessage error={errors.city} />}
                    </div>
                    <div className="">
                      <label htmlFor="Pincode" className="mb-1 font-md block capitalize font-semibold">
                        Pincode<span className="text-star_color">*</span>
                      </label>
                      <input
                        type="text"
                        id="Pincode"
                        name="pincode"
                        value={formValues.pincode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Enter Pincode"
                        className="p-2 border border-gray-300 rounded w-full"
                      />
                      {errors.pincode && <ErrorMessage error={errors.pincode} />}
                    </div>

                    <div className="relative">
                      <label htmlFor="Qualification" className="mb-1 font-md block capitalize font-semibold">
                        Qualification<span className="text-star_color">*</span>
                      </label>

                      <select
                        id="Qualification"
                        name="qualifiaction"
                        value={formValues.qualifiaction}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        className="p-2 border border-gray-300 rounded w-full"
                      >
                        <option value="" disabled>
                          Qualification
                        </option>
                        {EDUCATION_CHOICES?.map((item) => (
                          <option value={item?.value}>{item?.label}</option>
                        ))}
                      </select>

                      {errors.qualifiaction && (
                        <ErrorMessage error={errors.qualifiaction} />
                      )}
                    </div>
                    <div className="relative">
                      <label htmlFor="Occupation" className="mb-1 font-md block capitalize font-semibold">
                        Occupation<span className="text-star_color">*</span>
                      </label>
                      <select
                        id="Occupation"
                        name="ocuupation"
                        value={formValues.ocuupation}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        className="p-2 border border-gray-300 rounded w-full"
                      >
                        <option value="" disabled>
                          Occupation
                        </option>
                        {EMPLOYMENT_CHOICES?.map((item) => (
                          <option value={item?.value}>{item?.label}</option>
                        ))}
                      </select>
                      {errors.ocuupation && <ErrorMessage error={errors.ocuupation} />}
                    </div>
                    <div className="">
                      <label htmlFor="Age" className="mb-1 font-md block capitalize font-semibold">
                        Age<span className="text-star_color">*</span>
                      </label>
                      <input
                        type="text"
                        id="Age"
                        name="age"
                        value={formValues.age}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Age"
                        className="p-2 border border-gray-300 rounded w-full"
                      />

                      {errors.age && <ErrorMessage error={errors.age} />}
                    </div>
                    <div className="">
                      <label htmlFor="PropertyAddress" className="mb-1 font-md block capitalize font-semibold">
                        Property Address<span className="text-star_color">*</span>
                      </label>
                      <input
                        type="text"
                        id="PropertyAddress"
                        name="property_address"
                        value={formValues.property_address}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Enter Property Address"
                        className="p-2 border border-gray-300 rounded w-full"
                      />

                      {errors.property_address && (
                        <ErrorMessage error={errors.property_address} />
                      )}
                    </div>
                    <div className="col-span-2">
                      <label
                        htmlForfor="commercial_property"
                        className=" py-2 pointer-events-none font-semibold"
                      >
                        Commercial Property Details
                        <span className="text-star_color">*</span>
                      </label>
                      <textarea
                        className="block w-full px-2   py-1 text-base text-gray-700 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Enter Commercial Property Details"
                        id="commercial_property"
                        name="commercial_property"
                        value={formValues.commercial_property}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      ></textarea>
                      {errors.commercial_property && (
                        <ErrorMessage error={errors.commercial_property} />
                      )}
                    </div>
                  </div>
                  <div className="mt-4">
                    <div>
                      <input
                        type="checkbox"
                        id="agreementNo"
                        name="terms_conditions"
                        checked={formValues?.terms_conditions}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <label htmlFor="agreementNo" className="ml-4 font-sm text-sm">
                        I/We have carefully read and agree to the{" "}
                        <span className="text-primaryColor">Term & Conditions.</span>
                      </label>
                    </div>
                    {errors.terms_conditions && (
                      <ErrorMessage error={errors.terms_conditions} />
                    )}
                  </div>
                  <div className="flex justify-center items-center">
                    <button
                      type="submit"
                      className="bg-primaryColor text-white p-2 rounded mt-4 w-24 flex justify-center items-center focus:outline-none focus:shadow-outline"
                    >
                      {loading ? <Loader /> : "Next"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="flex-[0_0_25%] bg-[#fafafa] p-1 rounded-lg  mx-auto">


              <div className="bg-white p-2 mb-2 max-w-[320px]">
                {advertisementData
                  ?.filter((item) => ['SideBanner1'].includes(item?.category))
                  ?.map((filteredItem) => (
                    <a
                      key={filteredItem?.index}
                      href={filteredItem?.url}
                      target="_blank"
                      rel="noopener noreferrer"

                    >
                      <img key={filteredItem?.id} src={filteredItem?.image || "https://via.placeholder.com/150/FFFFFF/FFFFFF?text=No+Image"} alt={filteredItem} className="w-full h-[100px] " />
                    </a>
                  ))}
              </div>

              <div className="bg-white p-2 mb-2 max-w-[320px] ">
                {advertisementData
                  ?.filter((item) => ['SideBanner2'].includes(item?.category))
                  ?.map((filteredItem) => (
                    <a
                      key={filteredItem?.index}
                      href={filteredItem?.url}
                      target="_blank"
                      rel="noopener noreferrer"

                    >
                      <img key={filteredItem?.id} src={filteredItem?.image || "https://via.placeholder.com/150/FFFFFF/FFFFFF?text=No+Image"} alt={filteredItem} className="w-full" />
                    </a>
                  ))}
              </div>

              <div className="bg-white p-2 mb-2 max-w-[320px]">
                {advertisementData
                  ?.filter((item) => ['SideBanner3'].includes(item?.category))
                  ?.map((filteredItem) => (
                    <a
                      key={filteredItem?.index}
                      href={filteredItem?.url}
                      target="_blank"
                      rel="noopener noreferrer"

                    >
                      <img key={filteredItem?.id} src={filteredItem?.image || "https://via.placeholder.com/150/FFFFFF/FFFFFF?text=No+Image"} alt={filteredItem} className="" />
                    </a>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChannelPartnerRegistration;
